import { DEV__TOGGLE_ON_BACKGROUND_OFFLINE, DEV__RESET } from "../types/types"

const initialState = {
  offlineOnBackground: true,
}

export default function (state = initialState, action) {
  const { type } = action

  switch (type) {
    case DEV__TOGGLE_ON_BACKGROUND_OFFLINE:
      return {
        offlineOnBackground: action.enabled,
      }
    case DEV__RESET:
      return initialState
    default:
      return state
  }
}
